import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {updateSearchCondition, updateLogCondition} from '../../actions';
import _ from 'lodash';
import {Config} from '../../util';
import Api from '../../util/api/Api';

import Item from './item';

// TODO: 모든 선택 채널, 선택 해제 Toggle로 변경개발 하기

const modalRoot = document.getElementById('root');

class SelectContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chList: [],
      logoepgId: [],
      selectedChannelName: [],
      selectedChannelId: [],
      isSelectVisible: false
    };

    this.handleOnSelectContainerClick = this.handleOnSelectContainerClick.bind(this);
    this.handleOnChannelClick = this.handleOnChannelClick.bind(this);
    this.handleOnCheckAll = this.handleOnCheckAll.bind(this);

    this.handleOnCheckZero = this.handleOnCheckZero.bind(this);
  }

  componentDidMount() {
    this.getChList();
  }
  
  async getChList () {
    try{
      // if(!sessionStorage.getItem('chList')){
      //   const result = await Api.GetChList({chNo: ''}); 
      //   const useChList = result.files.ch.filter(ch => ch.use === 'Y');
      //   const chList = _.keyBy(useChList, 'chName');
      //   sessionStorage.setItem('chList', JSON.stringify(chList));
      // }
      // const chListObj = JSON.parse(sessionStorage.getItem('chList'));
      
      const useChList = Config.logoUrl;
      const chListObj = _.keyBy(useChList, 'epgId');
      const chKeys = Object.keys(chListObj);
      const chIdKeys = Object.keys(_.keyBy(chListObj, 'epgId'));
      this.setState({
        chList: chListObj,
        selectedChannelName: chKeys,
        selectedChannelId: chIdKeys
      }, () => {
        const initChCondition = _.chain(chListObj).values(chListObj).map(ch=>ch.epgId).value();
        this.props.type === "log" ? this.props.updateLogCondition(initChCondition)
          : this.props.updateSearchCondition(initChCondition);
      });
    } catch(e) {
      console.log(e);
    }
  }


  

  handleOnSelectContainerClick(event) {
    this.setState(prevState => { 
      return {isSelectVisible: !prevState.isSelectVisible}
    });
  }
  handleOnChannelClick(checked, chInfo) {
    const {
      chListObj,
      selectedChannelName,
      selectedChannelId
    } = this.state;
    let channels = selectedChannelName.slice();
    let channelIds = selectedChannelId.slice();
    if(checked){
      channels.push(chInfo.epgId);
      channelIds.push(chInfo.epgId);
      
    } else {
      channels = channels.filter(chName => chName !== chInfo.epgId);
      
      channelIds = channelIds.filter(chId => chId !== chInfo.epgId);
    }
    
    this.setState({
      selectedChannelName: channels,
      selectedChannelId: channelIds
    }, () => {
      this.props.type === "log" ? this.props.updateLogCondition(this.state.selectedChannelId)
        : this.props.updateSearchCondition(this.state.selectedChannelId);
    })
  }
  handleOnCheckAll(e){
    const {chList} = this.state;
    this.setState({
      selectedChannelName: Object.keys(chList),
      selectedChannelId: Object.keys(_.keyBy(chList,'epgId'))//Object.keys(chList).map(ch=>ch.chId)
    }, () => {
      this.props.type === "log" ? this.props.updateLogCondition(this.state.selectedChannelId)
        : this.props.updateSearchCondition(this.state.selectedChannelId);
    })
  }
  handleOnCheckZero(){
    this.setState({
      selectedChannelName: [],
      selectedChannelId: []
    }, () => {
      this.props.type === "log" ? this.props.updateLogCondition(this.state.selectedChannelId)
      : this.props.updateSearchCondition(this.state.selectedChannelId);
    })
  }
  handleOnBlur(e){
    e.preventDefault();
    e.stopPropagation();
    // setTimeout(() => {

      // if(e.currentTarget.getAttribute('class') === 'select-container'){
  
        this.setState(prevState => { 
          return {isSelectVisible: !prevState.isSelectVisible}
        });
      // }
    // },0);
    
  }


  renderChannelList(){
    const {
      chList,
      selectedChannelName
    } = this.state;
    const components = _.chain(chList)
            .mapValues()
            .values()
            .map(ch => 
            <Item ch={ch} key={ch.epgId}
                          checked={selectedChannelName.includes(ch.epgId)}
                          onChange={this.handleOnChannelClick}/>)
            .value();
    return components;
  }



  render() {
    const {
      chList,
      isSelectVisible,
      selectedChannelName
    } = this.state;
    const checkAll = selectedChannelName.length === Object.keys(chList).length;
    const checkZero = selectedChannelName.length === 0;
    const selectWrapClasses = 'select-wrap is-visible';
    const selectClasses = 'select-absolute is-visible';
    let logoepgId=[];
      for(let key of selectedChannelName){
        let epgId;
        epgId = _.keyBy(Config.logoUrl, 'epgId')[key].id;
        logoepgId.push(epgId);
      }

    return (
      <div className='select-container'>
      {isSelectVisible ? <div className='outside' 
                onClick={this.handleOnSelectContainerClick}></div> : null}
        <div className='element' onClick={this.handleOnSelectContainerClick}>
          {checkAll ? '모든 채널' : logoepgId.join(', ')}
          <span className="icon icon-select-down"></span>
        </div>
            {/* {isSelectVisible && 
            <div className={selectWrapClasses}>
              <div className={selectClasses}>
                <div className='menu'>
                  <div className='item' onClick={this.handleOnCheckAll}>
                    <input type="checkbox"
                     checked={checkAll}
                     onChange={this.handleOnCheckAll} />
                    모든 채널 선택
                  </div>
                  <div className='item' onClick={this.handleOnCheckZero}>
                    <input type ="checkbox"
                    checked={checkZero} 
                    onChange={this.handleOnCheckZero} />
                    모든 채널 선택해제
                  </div>
                  <div className='item icon icon-close' onClick={this.handleOnSelectContainerClick}></div>
                </div>
                <div className='grid-container'>
                  {this.renderChannelList()}
                </div>
              </div>
            </div>} */}

          {isSelectVisible && 
            <div className={selectWrapClasses}>
              <div className={selectClasses}>
                <div className='grid-container'>
                  {this.renderChannelList()}
                </div>
                <div className='menu'>
                    <button type="button"
                     onClick={this.handleOnCheckAll} >
                    모든 채널 선택
                    </button>
                  <button type ="button"
                    onClick={this.handleOnCheckZero}>
                    모든 채널 선택해제
                  </button>
                  <button type="button" 
                    onClick={this.handleOnSelectContainerClick}>
                    확 인
                  </button>
                </div>
              </div>
            </div>
            }


      </div>
    )
  }
}

const mapDispatcherToProps = dispatch => {
  return {
    updateSearchCondition: (chs) => dispatch(updateSearchCondition({chs:chs.join(',')})),
    updateLogCondition: (chs) => dispatch(updateLogCondition({chs:chs.join(',')})),
  }
};


SelectContainer = connect(undefined, mapDispatcherToProps)(SelectContainer);

export default SelectContainer;


// WEBPACK FOOTER //
// ./src/components/select/index.js